import { useContext, useEffect, useState } from "react";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { RouteContext } from "../../user/screen/components/route.context";
import { brandService } from "../service/brand.service";
import BrandTable from "./component/BrandTable";
import { Brand, BrandUI } from "../entity/brand.model";
import { useNavigate } from "react-router";
import helper from "../../../../helper/helper";

function Brands() {
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [brand, setBrand] = useState<BrandUI[]>([]);
  const navigate = useNavigate();

  const pageChange = () => {
    dispatch({ type: spinActions.BLOCK });
    brandService
      .getBrands()
      .then((_brands: BrandUI[]) => {
        // setBrand(response);
        _brands.map((item, index) => {
          helper.getImage("/public" + "/" + item.imagePath).then((file) => {
            _brands[index].file = file;
          });
        });
        setBrand(_brands);
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });
  };

  useEffect(() => {
    pageChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.routeId]);

  return (
    <>
      <MPageHeader crumbs={["Брэнд"]} />
      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h6 className="card-title">Брэндүүд</h6>

            <div className="header-elements">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => navigate("/brand/add")}
              >
                <i className="icon-plus2 pr-1"></i>
                Брэнд нэмэх
              </button>
            </div>
          </div>
          <div className="card-body">
            <BrandTable
              data={brand}
              onReload={() => {
                pageChange();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Brands;
